<template>
  <main id="controls-container" :class="{ 'captions-on': showCaptions }">
    <h1>Ambient ScotRail Beats</h1>
    <div id="controls">
      <div class="control">
        <div class="label"><label for="preset">Beats</label></div>
        <div class="widget">
          <select v-model="selectedPresetUrl" id="preset">
            <option
              v-for="preset in presets"
              :value="preset.url"
              :key="preset.url"
            >
              {{ preset.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="control">
        <div class="label"></div>
        <div class="widget">
          <a :href="ytVideoURL" class="yt-link" target="_blank"
            >Listen on YouTube</a
          >
        </div>
      </div>
      <div class="control">
        <div class="label"><label for="yt-url">YouTube URL</label></div>
        <div class="widget">
          <input type="text" id="yt-url" v-model="newYTVideoURL" />
          <button @click="setYTVideoURl" id="yt-url-set">Set</button>
        </div>
      </div>

      <div class="control">
        <div class="label">
          <label for="announcement-volume">Announcement volume</label>
        </div>
        <div class="widget">
          <input
            class="range"
            type="range"
            id="announcement-volume"
            min="0"
            max="2"
            step="0.01"
            v-model.number="announcementVolume"
          />
        </div>
      </div>

      <div class="control">
        <div class="label">
          <label for="announcement-frequency">Announcement frequency</label>
        </div>
        <div class="widget">
          <input
            class="range"
            type="range"
            id="announcement-frequency"
            min="0"
            max="30000"
            step="500"
            v-model.number="announcementFrequency"
          />
        </div>
      </div>

      <div class="control">
        <div class="label"><label for="delay">Delay</label></div>
        <div class="widget">
          <input
            class="range"
            type="range"
            id="delay"
            min="0.001"
            max="1"
            step="0.001"
            v-model.number="delayAmount"
          />
        </div>
      </div>

      <div class="control">
        <div class="label"><label for="enable-captions">Captions</label></div>
        <div class="widget align-left">
          <input
            class="checkbox"
            type="checkbox"
            id="enable-captions"
            v-model="showCaptions"
          />
        </div>
      </div>

      <button
        @click="play"
        v-if="!playing"
        aria-label="Play"
        class="play-pause"
        ref="play"
      >
        <svg
          class="control-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 35.72 50.33"
          data-v-4f106672=""
        >
          <path
            d="M976.17,537.58l-28.39-21.5A3.67,3.67,0,0,0,941.9,519v43a3.67,3.67,0,0,0,5.88,2.93l28.39-21.5A3.67,3.67,0,0,0,976.17,537.58Z"
            transform="translate(-941.9 -515.33)"
            fill="currentColor"
            data-v-4f106672=""
          ></path>
        </svg>
      </button>
      <button @click="pause" v-if="playing" class="play-pause" ref="pause">
        <svg
          class="control-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 35.76 50.25"
          aria-visbile="false"
          data-v-4f106672=""
        >
          <rect
            width="14.47"
            height="50.25"
            rx="3.57"
            fill="currentColor"
            data-v-4f106672=""
          ></rect>
          <rect
            x="21.29"
            width="14.47"
            height="50.25"
            rx="3.57"
            fill="currentColor"
            data-v-4f106672=""
          ></rect>
        </svg>
      </button>
    </div>
    <button id="share" @click="share">
      <img src="./assets/share.png" width="15" alt="" /> Share this mix
    </button>
  </main>
  <aside id="player-container" aria-hidden="true">
    <div id="player"></div>
  </aside>
  <aside id="captions" v-if="showCaptions">
    {{ caption }}
  </aside>
  <footer class="credits">
    Built by
    <a href="https://twitter.com/MattEason" target="_blank">Matt Eason</a>
    &bull; Buy me a coffee on
    <a href="https://ko-fi.com/matteason">Ko-fi</a> &bull; More ambience on
    <a href="https://ambiph.one">Ambiphone</a> &bull; Announcements &copy;
    ScotRail, voiced by
    <a href="https://www.alisonmckay.com/" target="_blank">Alison McKay</a>
  </footer>
</template>

<script>
import { Delay } from "@shyrii/web-audio-effects";
import { captions } from "./captions";

export default {
  name: "App",
  data() {
    return {
      presets: [
        {
          name: "lofi hip hop radio - beats to relax/study to by Lowfi Girl",
          url: "https://www.youtube.com/watch?v=jfKfPfyJRdk",
        },
        {
          name: "lofi hip hop radio - beats to sleep/chill to by Lowfi Girl",
          url: "https://www.youtube.com/watch?v=rUxyKA_-grg",
        },
        {
          name: "Ambient Study Music To Concentrate by Quiet Quest - Study Music",
          url: "https://www.youtube.com/watch?v=sjkrrmBnpGE",
        },
      ],
      selectedPresetUrl: "https://www.youtube.com/watch?v=jfKfPfyJRdk",
      playing: false,
      audio: null,
      audioContext: null,
      processedAudio: null,
      gainNode: null,
      delayNode: null,
      reverbNode: null,
      announcementNumber: null,
      announcementTimeout: null,
      ytPlayer: null,
      ytPlayerReady: false,
      newYTVideoURL: null,
      ytVideoURL: "https://www.youtube.com/watch?v=jfKfPfyJRdk",
      announcementVolume: 0.5,
      delayAmount: 0.5,
      announcementFrequency: 15000,
      caption: "",
      showCaptions: false,
    };
  },

  mounted() {
    const searchParams = new URLSearchParams(window.location.search);
    const yturl = searchParams.get("yturl");
    const vol = searchParams.get("vol");
    const delay = searchParams.get("delay");
    const frequency = searchParams.get("frequency");

    if (yturl) {
      this.ytVideoURL = yturl;
      this.newYTVideoURL = yturl;
    }

    if (vol) {
      this.announcementVolume = vol;
    }

    if (frequency) {
      this.announcementFrequency = frequency;
    }

    if (delay) {
      this.delayAmount = delay;
    }

    this.setupYTPlayer();
  },

  computed: {
    ytVideoID() {
      return this.ytUrlToId(this.ytVideoURL);
    },
  },

  watch: {
    announcementVolume() {
      if (this.gainNode) {
        this.gainNode.gain.value = this.announcementVolume;
      }
      this.updateQueryString();
    },
    announcementFrequency() {
      clearTimeout(this.announcementTimeout);
      this.cueNextAnnouncement();
      this.updateQueryString();
    },
    delayAmount() {
      if (this.delayNode) {
        this.delayNode.updateParams({
          feedback: this.delayAmount,
        });
      }
      this.updateQueryString();
    },
    selectedPresetUrl() {
      this.ytVideoURL = this.selectedPresetUrl;
      if (!this.playing) {
        this.play();
      }
    },
    ytVideoID() {
      if (this.ytPlayerReady) {
        if (this.playing) {
          this.ytPlayer.loadVideoById(this.ytVideoID, 0);
        } else {
          this.ytPlayer.cueVideoById(this.ytVideoID, 0);
        }
      }
      this.updateQueryString();
    },
  },

  methods: {
    updateQueryString() {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("yturl", this.ytVideoURL);
      searchParams.set("vol", this.announcementVolume);
      searchParams.set("frequency", this.announcementFrequency);
      searchParams.set("delay", this.delayAmount);
      const newRelativePathQuery =
        window.location.pathname + "?" + searchParams.toString();
      history.replaceState(null, "", newRelativePathQuery);
    },
    ytUrlToId(url) {
      //https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },
    setYTVideoURl() {
      if (this.ytUrlToId(this.newYTVideoURL)) {
        this.ytVideoURL = this.newYTVideoURL;
        this.newYTVideoURL = null;
      } else {
        alert("Sorry, I didn't recognise that YouTube URL");
      }
    },
    play() {
      if (!this.audioContext) {
        this.setupAudio();
      }

      this.playing = true;

      if (this.ytPlayerReady) {
        this.ytPlayer.playVideo();
      }

      this.$nextTick(() => {
        this.$refs.pause.focus();
      });
    },
    pause() {
      this.playing = false;
      this.audio.pause();
      if (this.ytPlayerReady) {
        this.ytPlayer.pauseVideo();
      }

      this.$nextTick(() => {
        this.$refs.play.focus();
      });
    },
    randomIntFromInterval(min, max) {
      // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    randomAnnouncementNumber() {
      return this.randomIntFromInterval(1, 2440).toString().padStart(4, "0");
    },
    cueNextAnnouncement() {
      const ms = this.randomIntFromInterval(0, this.announcementFrequency);
      //console.log(`Next announcement in ${ms}`);
      this.announcementTimeout = setTimeout(this.playAnnouncement, ms);
      this.caption = "";
    },
    setupAudio() {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      this.audioContext = new AudioContext();
      this.announcementNumber = this.randomAnnouncementNumber();
      this.audio = new Audio();
      this.audio.crossOrigin = "anonymous";
      this.processedAudio = this.audioContext.createMediaElementSource(
        this.audio
      );

      this.gainNode = this.audioContext.createGain();
      this.gainNode.gain.value = this.announcementVolume;

      this.delayNode = new Delay(this.audioContext, {
        type: 2,
        delay: 5.0,
        feedback: this.delayAmount,
        offset: 0,
        cutoff: 800,
        dry: 1,
      });
      this.processedAudio.connect(this.gainNode).connect(this.delayNode.input);
      this.delayNode.connect(this.audioContext.destination);

      this.audio.addEventListener("ended", () => {
        this.cueNextAnnouncement();
      });
    },

    playAnnouncement() {
      if (!this.playing) {
        return;
      }

      this.announcementNumber = this.randomAnnouncementNumber();
      this.audio.src = `https://matteason.github.io/scotrail-announcements-june-2022/announcements/${this.announcementNumber}.mp3`;
      this.audio.play();
      const caption = captions[parseInt(this.announcementNumber) - 1].caption;
      //console.log(caption);
      this.caption = caption;
    },
    setupYTPlayer() {
      // 2. This code loads the IFrame Player API code asynchronously.
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      window.onYouTubeIframeAPIReady = () => {
        this.ytPlayer = new window.YT.Player("player", {
          height: window.innerHeight + 40,
          width: window.innerWidth + 40,
          videoId: this.ytVideoID,
          playerVars: {
            playsinline: 1,
            controls: 0,
          },
          events: {
            onReady: this.onYTPlayerReady,
            onStateChange: this.onYTPlayerStateChange,
          },
        });
      };
    },
    resizeYTPlayer() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      let frameWidth = 0;
      let frameHeight = 0;

      if (windowWidth > windowHeight) {
        frameWidth = windowWidth;
        frameHeight = Math.round(windowWidth * 0.5625);
      } else {
        frameWidth = Math.round(windowHeight * 1.777);
        frameHeight = windowHeight;
      }

      document.getElementById("player").width = frameWidth;
      document.getElementById("player").height = frameHeight;
      document.getElementById("player").style.width = frameWidth + "px";
      document.getElementById("player").style.height = frameHeight + "px";
    },

    onYTPlayerReady() {
      this.ytPlayerReady = true;
      this.resizeYTPlayer();
      window.addEventListener("resize", this.resizeYTPlayer);
      if (this.playing) {
        this.ytPlayer.playVideo();
      }
    },
    onYTPlayerStateChange(e) {
      if (e.data === 0 && this.playing) {
        this.ytPlayer.playVideo();
      }

      if (e.data === 1) {
        setTimeout(this.playAnnouncement, 500);
      }
    },
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: "Ambient ScotRail Beats",
            text: "Listen to my Ambient ScotRail Beats mix",
            url: window.location,
          })
          .then(() => {})
          .catch(console.error);
      } else {
        navigator.clipboard.writeText(window.location);
        alert("URL copied to clipboard");
      }
    },
  },
};
</script>

<style lang="scss">
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

#controls-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &.captions-on {
    @media (max-width: 700px) {
      justify-content: flex-start;
    }
  }
}

h1 {
  text-transform: uppercase;
  letter-spacing: 3px;
  text-align: center;
  font-family: Montserrat, sans-serif;
  color: white;
  margin: 20px 20px 20px 20px;
  text-shadow: 0 0 10px black;
}

#controls {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  max-width: calc(100% - 80px);
  width: 400px;
  padding: 30px;
  border-radius: 15px;
  font-family: Montserrat, sans-serif;
  color: white;
  margin: 0 20px;
}

.play-pause {
  background: 0;
  border: 0;
  margin: 0 auto;
  margin-top: 15px;
  display: block;
}

.control {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.label {
  width: 45%;
  text-align: right;
}

.widget {
  width: 50%;
  display: flex;

  &.align-left {
    align-items: flex-start;
  }

  input {
    flex-grow: 1;
    flex-shrink: 1;
    width: 5px;
  }

  input[type="text"],
  select {
    border: none;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 3px 0 0 3px;
    font-family: Montserrat, sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    max-width: 100%;
    color: black;
  }

  input[type="text"] {
    padding-right: 0;
  }

  select {
    border-radius: 3px;
  }

  .range {
    background: transparent;
    -webkit-appearance: none;

    // Track and thumb styling doesn't work in Chrome when the selector targets both prefixed pseudoelements
    @mixin track {
      background: white;
      height: 6px;
      border-radius: 3px;
      width: 100%;
    }

    &::-webkit-slider-runnable-track {
      @include track;
    }

    &::-moz-range-track {
      @include track;
    }

    @mixin thumb {
      height: 24px;
      width: 24px;
      border: 3px solid white;
      background: white;
      box-shadow: none;
      border-radius: 50%;
      -webkit-appearance: none;
      margin-top: -8px;
      box-sizing: border-box;
      cursor: grab;

      &:active {
        cursor: grabbing;
      }
    }

    &::-webkit-slider-thumb {
      @include thumb;
    }

    &::-moz-range-thumb {
      @include thumb;
    }
  }

  .checkbox {
    flex-grow: 0;
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
  }
}

#yt-url-set {
  background: white;
  color: black;
  border-radius: 0 3px 3px 0;
  border: 1px solid white;
  font-family: Montserrat, sans-serif;
  font-size: 1rem;
  padding: 0.5rem 1rem;
}

.control-icon {
  width: 30px;
  color: white;
  display: block;
}

#player-container {
  touch-action: none;
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  overflow: hidden;
  background: black;
}
#player {
  filter: blur(20px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.2);
}

.yt-link {
  color: white;
  font-size: 0.75rem;
  margin-top: -12px;
}

.credits {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  z-index: 100;
  font-family: Montserrat, sans-serif;
  font-size: 0.75rem;
  opacity: 0.5;
  line-height: 1.2rem;
  padding: 0 20px;
  text-shadow: 0 0 10px black;
  a {
    color: white;
  }
}

#captions {
  position: absolute;
  bottom: 80px;
  left: 20px;
  right: 20px;
  text-align: center;
  color: white;
  z-index: 100;
  font-family: Montserrat, sans-serif;
  font-size: 1.5rem;
  line-height: 1.2rem;
  padding: 0 20px;
  text-shadow: 0 0 10px black;
  line-height: 1.3em;

  @media (max-width: 700px) {
    font-size: 1rem;
  }

  a {
    color: white;
  }
}

#share {
  color: white;
  text-shadow: 0 0 10px black;
  font-family: Montserrat, sans-serif;
  background: none;
  margin-top: 1rem;
  border: none;
  vertical-align: middle;

  img {
    vertical-align: -4px;
    margin-right: 3px;
    cursor: pointer;
    filter: drop-shadow(0px 0px 5px black);
  }
}
</style>
